var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReservedTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.164062,
    width: 113.583,
    height: 113.583,
    fill: "#9C4F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedTableIcon);
export default __webpack_public_path__ + "static/media/reserved-table-icon.be8b7cf5952fbe684c2fd25cd1bf3bb6.svg";
export { ForwardRef as ReactComponent };